import {
  Dropdown,
  InputLine,
  Radio,
} from '@quero-delivery/quero-components-web';
import { Controller, useFormContext } from 'react-hook-form';
import { cnpjLabel, cpfLabel } from '@/Utils/FnUtils';
import { useBanksList } from '@/_features/motoboys/deliveryman-form/hooks/use-banks-list';
import styles from './bank-data-form.module.scss';
import type { DeliverymanFormType } from '../../types';
import { ACCOUNTS_TYPES_OPTIONS } from '../../constants';

function BankDataForm() {
  const {
    control,
    watch,
    setValue,
    formState: { errors },
  } = useFormContext<DeliverymanFormType>();

  const tipoPessoaSelected = watch('tipoPessoa');

  const { banksOptions, isLoading: loadingBanks } = useBanksList();

  return (
    <div className={styles.container}>
      <span className={styles.subtitleForm}>Dados bancários</span>

      <div className={styles.form}>
        <div className={styles.twoLines}>
          <div className={styles.lineLeft}>
            <Controller
              control={control}
              name="contaBancaria.banco"
              render={({ field: { onChange, value } }) => (
                <Dropdown
                  label="Banco"
                  clearable
                  placeholder="Selecione o banco"
                  options={banksOptions}
                  errorMessage={errors.contaBancaria?.banco?.message}
                  value={value}
                  onChange={(event, data) => onChange(data.value)}
                  disabled={loadingBanks}
                  loading={loadingBanks}
                  search
                />
              )}
            />
          </div>
          <div className={styles.lineRight}>
            <Controller
              control={control}
              name="contaBancaria.tipoConta"
              render={({ field: { onChange, value } }) => (
                <Dropdown
                  label="Tipo conta"
                  clearable
                  placeholder="Selecione o tipo de conta"
                  options={ACCOUNTS_TYPES_OPTIONS}
                  errorMessage={errors.contaBancaria?.tipoConta?.message}
                  value={value}
                  onChange={(event, data) => onChange(data.value)}
                />
              )}
            />
          </div>
        </div>
        <div className={styles.twoLines}>
          <div className={styles.bankLeft}>
            <Controller
              name="contaBancaria.bancoAgencia"
              control={control}
              render={({ field: { onChange, value } }) => (
                <InputLine
                  label="Agência"
                  onChange={event => onChange(event.target.value)}
                  value={value}
                  errorMessage={errors.contaBancaria?.bancoAgencia?.message}
                />
              )}
            />
          </div>
          <strong>-</strong>
          <div className={styles.bankRight}>
            <Controller
              name="contaBancaria.bancoAgenciaDigito"
              control={control}
              render={({ field: { onChange, value } }) => (
                <InputLine
                  label="Dígito"
                  onChange={event => onChange(event.target.value)}
                  value={value}
                  errorMessage={
                    errors.contaBancaria?.bancoAgenciaDigito?.message
                  }
                />
              )}
            />
          </div>
        </div>
        <div className={styles.twoLines}>
          <div className={styles.bankLeft}>
            <Controller
              name="contaBancaria.numeroConta"
              control={control}
              render={({ field: { onChange, value } }) => (
                <InputLine
                  label="Conta"
                  onChange={event => onChange(event.target.value)}
                  value={value}
                  errorMessage={errors.contaBancaria?.numeroConta?.message}
                />
              )}
            />
          </div>
          <strong>-</strong>
          <div className={styles.bankRight}>
            <Controller
              name="contaBancaria.digitoConta"
              control={control}
              render={({ field: { onChange, value } }) => (
                <InputLine
                  label="Dígito"
                  onChange={event => onChange(event.target.value)}
                  value={value}
                  errorMessage={errors.contaBancaria?.digitoConta?.message}
                />
              )}
            />
          </div>
        </div>
        <Controller
          name="tipoPessoa"
          control={control}
          render={({ field: { onChange, value } }) => (
            <div className={styles.containerRadioTipoConta}>
              <Radio
                label="Pessoa Jurídica"
                checked={value === 'juridica'}
                onChange={() => {
                  onChange('juridica');
                  setValue('contaBancaria.cpfCnpjDestinatario', '');
                }}
              />
              <Radio
                label="Pessoa Física"
                checked={value === 'fisica'}
                onChange={() => {
                  onChange('fisica');
                  setValue('contaBancaria.cpfCnpjDestinatario', '');
                }}
              />
              {errors.tipoPessoa && (
                <p className="text-error">{errors.tipoPessoa.message}</p>
              )}
            </div>
          )}
        />
        <div className={styles.twoLines}>
          <div className={styles.lineLeft}>
            <Controller
              name="contaBancaria.nomeDestinatario"
              control={control}
              render={({ field: { onChange, value } }) => (
                <InputLine
                  label="Nome destinatário"
                  onChange={event => onChange(event.target.value)}
                  value={value}
                  errorMessage={errors.contaBancaria?.nomeDestinatario?.message}
                />
              )}
            />
          </div>
          <div className={styles.lineRight}>
            <Controller
              name="contaBancaria.cpfCnpjDestinatario"
              control={control}
              render={({ field: { onChange, value } }) => (
                <InputLine
                  label={tipoPessoaSelected === 'juridica' ? 'CNPJ' : 'CPF'}
                  onChange={event =>
                    onChange(
                      tipoPessoaSelected == 'fisica'
                        ? cpfLabel(event.target.value)
                        : cnpjLabel(event.target.value),
                    )
                  }
                  value={value}
                  maxLength={18}
                  errorMessage={
                    errors.contaBancaria?.cpfCnpjDestinatario?.message
                  }
                />
              )}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export { BankDataForm };
